<template>
  <tr>
    <td
      class="!h-80 border-0 bg-white"
      colspan="99"
    >
      <p class="text-center w-full block mt-6 text-secondary-emphasis text-lg mx-auto">
        <slot name="empty">
          There are no results
        </slot>
      </p>
    </td>
  </tr>
</template>

<script setup>

</script>
